
import Vue from 'vue'
export default Vue.extend({
  computed: {
    activeTab: {
      get() {
        return this.$route.name
      },
      set(name: string) {
        this.$router.push({ name })
      }
    },
    top() {
      const { clientWidth } = document.documentElement
      return clientWidth > 768
        ? (clientWidth / 1680) * 108
        : (clientWidth / 375) * 54
    }
  }
})
